function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_19946",
  "data-name": "Group 19946",
  transform: "translate(-1112.584 -793.156)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(189.559 526.519)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16942",
  "data-name": "Group 16942",
  transform: "translate(996.106 266.638)",
  opacity: 0.294
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16960",
  "data-name": "Group 16960",
  transform: "translate(930.478 307.437)",
  opacity: 0.19
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2778",
  "data-name": "Ellipse 2778",
  transform: "translate(1028.128 324.458)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2779",
  "data-name": "Ellipse 2779",
  transform: "translate(1036.568 276.574)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.17
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2780",
  "data-name": "Ellipse 2780",
  transform: "translate(923.026 328.184)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.294
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_2216",
  "data-name": "Line 2216",
  x2: 31.609,
  transform: "translate(1019.775 297.921)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2217",
  "data-name": "Line 2217",
  x2: 33.988,
  transform: "translate(1019.435 307.437)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_8",
  "data-name": "Group 8",
  transform: "translate(167.559 36.808)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18022",
  "data-name": "Group 18022",
  transform: "translate(976.529 763.489)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_57",
  "data-name": "Union 57",
  d: "M32.041,54.358l-5.5-2.763-5.51,2.763a2.141,2.141,0,0,1-3.082-2.226l.945-6.071L14.553,41.7A2.13,2.13,0,0,1,15.725,38.1l6.088-.985,2.822-5.461a2.141,2.141,0,0,1,3.8,0l2.82,5.461,6.092.985A2.13,2.13,0,0,1,38.525,41.7l-4.346,4.36.947,6.071a2.14,2.14,0,0,1-2.115,2.456A2.193,2.193,0,0,1,32.041,54.358Zm.76-1.49a.456.456,0,0,0,.475-.039.466.466,0,0,0,.186-.439L32.393,45.48l4.943-4.959a.459.459,0,0,0-.258-.771l-6.926-1.125-3.211-6.213a.453.453,0,0,0-.809,0l-3.217,6.213L16,39.75a.459.459,0,0,0-.365.306.484.484,0,0,0,.107.465l4.941,4.959L19.615,52.39a.459.459,0,0,0,.658.479l6.268-3.151Zm17.91-.13-3.824-1.956-3.828,1.956h.006a.469.469,0,0,1-.658-.515l.732-4.1-3.074-2.909a.484.484,0,0,1,.258-.826l4.262-.606,1.9-3.753a.441.441,0,0,1,.8,0L49.2,43.78l4.266.606a.48.48,0,0,1,.24.826l-3.068,2.909.727,4.1a.469.469,0,0,1-.449.565A.437.437,0,0,1,50.711,52.738Zm-39.92,0L6.963,50.782l-3.82,1.956a.459.459,0,0,1-.646-.515l.723-4.1L.146,45.212a.485.485,0,0,1,.246-.826L4.66,43.78l1.9-3.753a.447.447,0,0,1,.811,0l1.9,3.753,4.27.606a.484.484,0,0,1,.248.826l-3.072,2.909.725,4.1a.469.469,0,0,1-.449.565A.427.427,0,0,1,10.791,52.738ZM41.256,35.146V27.26a2.676,2.676,0,0,0-1.545-2.472,30.781,30.781,0,0,0-12.777-2.8h-.125c-.275,0-.555.007-.859.013S25.365,22,25.094,22h-.127a30.8,30.8,0,0,0-12.779,2.792,2.686,2.686,0,0,0-1.545,2.472v7.887a1.33,1.33,0,0,1-2.66,0V27.26a5.417,5.417,0,0,1,3.076-4.881,34.265,34.265,0,0,1,14.027-3.033c.279,0,.566.006.863.013.3-.013.584-.013.863-.013a34.267,34.267,0,0,1,14.029,3.033,5.414,5.414,0,0,1,3.082,4.881v7.887a1.334,1.334,0,0,1-2.668,0ZM15.785,9.282A9.312,9.312,0,1,1,25.1,18.564,9.3,9.3,0,0,1,15.785,9.282Zm2.658.1A6.653,6.653,0,1,0,25.1,2.759,6.642,6.642,0,0,0,18.443,9.387Z",
  transform: "translate(0)",
  fill: "#202f43",
  opacity: 0.552
}))));

function SvgContinue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.398,
    height: 68.999,
    viewBox: "0 0 130.398 68.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinue);
export default __webpack_public_path__ + "static/media/continue.158703e7.svg";
export { ForwardRef as ReactComponent };